import { useQuery } from '@tanstack/react-query';
import { Cloud, Cpu, Sparkles } from 'lucide-react';
import { Api } from '../../lib/api';
import { useAgent } from '../../store/agent';
import { useUi } from '../../store/ui';

const CONSOLE: Record<string, string> = { anthropic: 'https://platform.claude.com/' };

/**
 * Topbar chip: which model would answer right now, and whether it is reachable. Clicking a cloud
 * provider opens its console (usage, keys, billing) in a new tab; a local provider has no console,
 * so the click opens the agent instead. Ctrl+J always opens the agent.
 */
export function ProviderChip() {
  const q = useQuery({ queryKey: ['providers'], queryFn: Api.agent.providers, refetchInterval: 60_000, staleTime: 30_000 });
  const provider = useAgent((s) => s.session?.provider);
  const status = useAgent((s) => s.status);
  const setDockTab = useUi((s) => s.setDockTab);
  const p = q.data?.providers.find((x) => x.id === (provider ?? q.data?.default));
  const cls = !q.data ? '' : !p || !p.ok ? 'crit' : status === 'RUNNING' ? 'teal' : status === 'AWAITING_APPROVAL' ? 'warn' : 'ok';
  const text = !q.data ? 'agent' : !p ? 'no model' : !p.ok ? `${p.id} down` : status === 'RUNNING' ? 'working…' : status === 'AWAITING_APPROVAL' ? 'approval needed' : p.id;
  const consoleUrl = p ? CONSOLE[p.id] : undefined;
  const openAgent = () => (setDockTab('agent'), setTimeout(() => document.dispatchEvent(new CustomEvent('cortex:ask', { detail: '' })), 50));
  const onClick = () => (consoleUrl ? window.open(consoleUrl, '_blank', 'noopener,noreferrer') : openAgent());
  const title = p ? `${p.model} · ${p.detail}${consoleUrl ? ' · click: open the Anthropic console' : ' · click: open the agent'}` : 'Open agent (Ctrl+J)';
  return (
    <button className={`chip ${cls}`} title={title} onClick={onClick}>
      {p?.remote === false ? <Cpu size={11} /> : p ? <Cloud size={11} /> : <Sparkles size={11} />} {text}
    </button>
  );
}
